import { render, staticRenderFns } from "./applyExte.vue?vue&type=template&id=9906034a&scoped=true"
import script from "./applyExte.vue?vue&type=script&lang=js"
export * from "./applyExte.vue?vue&type=script&lang=js"
import style0 from "./applyExte.vue?vue&type=style&index=0&id=9906034a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9906034a",
  null
  
)

export default component.exports